export default "__VITE_ASSET__54399be7__"